import { arrInc } from '../../fun-js-lib/arr'
import Box from '../../fun-js-lib/geometry/Box'
import Dot from '../../fun-js-lib/geometry/Dot'
import Rect from '../../fun-js-lib/geometry/Rect'
import { drawFrame, drawZLine, fillStyled, rectColored } from '../canvasDraw'
import { maxNLinesOnMainPageWorkDescription } from './lower/workDescription'
import { baseLineInterval } from './otherPageImg'
import { mainFrameRect, pageNumberRect } from './rects'
import { signatureTopY } from './signatureTopY'
import { nLinesInWorkDescription } from './texts'

/**
 * @param {CanvasRenderingContext2D} context 
 * @param {string} linesColor 
 */
export function drawGrandVerticalLine (context, linesColor) {
  let frame = mainFrameRect()
  let x = frame.x + 1000 + 790
  fillStyled(context, linesColor, () =>
    context.fillRect(x, frame.y, 5, 1780 - 100)
  )
}

/**
 * @param {CanvasRenderingContext2D} context 
 * @param {string} linesColor 
 */
export function draw3GrandHorizontalLines (context, linesColor) {
  let frame = mainFrameRect()
  let x = frame.x
  let y = frame.y + 250
  fillStyled(context, linesColor, () => {
    context.fillRect(x, y, frame.w, 5)
    context.fillRect(x, y + 360, frame.w, 5)
    context.fillRect(x, signatureTopY(), frame.w, 5)
  })
}

/**
 * @param {CanvasRenderingContext2D} context 
 * @param {string} linesColor 
 */
export function draw2SignatureVerticalLines (context, linesColor) {
  let frame = mainFrameRect()
  let x = frame.x + 850
  let y = signatureTopY()
  fillStyled(context, linesColor, () => {
    context.fillRect(x, y, 5, 100)
    context.fillRect(x + 855, y, 5, 100)
  })
}

/**
 * @param {CanvasRenderingContext2D} context 
 * @param {string} linesColor 
 */
export function drawPageNumberRect (context, linesColor) {
  let rect = pageNumberRect()
  fillStyled(context, linesColor, () => {
    drawFrame(context, rect, 1)
  })
}

/**
 * @param {CanvasRenderingContext2D} context 
 * @param {string} linesColor 
 */
export function drawContentHorizontalLines (context, linesColor) {
  let frame = mainFrameRect()
  let x = frame.x
  let y = frame.y + 250 + 360
  let contentLine = baseLineInterval()
  fillStyled(context, linesColor, () => {
    context.fillRect(x, y + 70, frame.w, 5)
    arrInc(17).map(i =>
      context.fillRect(x, y + 70 + Math.round((i + 1) * contentLine), frame.w, 1))
  })
}

/**
 * @param {CanvasRenderingContext2D} context 
 * @param {string} linesColor 
 */
export function drawSmallVerticalLine (context, linesColor) {
  let frame = mainFrameRect()
  rectColored(context, frame.x + 1000, frame.y, 1, 250, linesColor)
}

/**
 * @param {CanvasRenderingContext2D} context 
 * @param {import('../constructionLog').LogPage} page 
 */
export function drawZOnOther (context, page) {
  const overall = nLinesInWorkDescription(context, page.work_description, page.number)
  const nLinesOnOtherPage = Math.max(overall - maxNLinesOnMainPageWorkDescription, 0)
  let frame = mainFrameRect()
  let linesHeight = nLinesOnOtherPage * baseLineInterval()
  let rect = new Rect({
    dot: new Dot({
      x: frame.x + 8,
      y: frame.y + 28 + linesHeight
    }),
    box: new Box({
      w: frame.w - 16,
      h: frame.h - linesHeight - 36
    })
  })
  drawZLine(context, rect)
}